<template>

  <td class="celda">
    <span v-if="nombre != null">
      {{ nombre }}
    </span>
    <span v-else>
      -
    </span>
  </td>

</template>

<script>

export default {
  name: 'Celda-Component',
  props: {
    nombre: [String, Number, Date, Object, Array]
  },
  data() {
    return {
    }
  },
  created() {
  },
  async mounted() {

  },
  methods: {},
  filters: {}
};
</script>

<style scoped>
  .celda {
    height: 26px;
  }
</style>
<script setup lang="ts">
</script>